import { render } from "./아이디_비밀번호 찾기완료.vue?vue&type=template&id=6a64139a"
import script from "./아이디_비밀번호 찾기완료.vue?vue&type=script&lang=js"
export * from "./아이디_비밀번호 찾기완료.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__